import { useQuery } from 'react-query';
import { API } from 'api';

export interface IMerchantRequestListData {
  payload: {
    page?: number;
    from?: number;
    to?: number;
    mid?: string;
    name?: string;
    status?: string;
  };
  data: {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    data: any;
    count: number;
  };
}

export const initMerchantRequestListPayload: IMerchantRequestListData['payload'] = {
  page: 1,
  status: 'pending',
};

const getEmployerRequestListData = (data: IMerchantRequestListData['payload']) => {
  return API.get()('/api/admin/merchantRequest/all', data);
};

export const useMerchantRequestListData = (data: IMerchantRequestListData['payload']) => {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  return useQuery(['merchantRequests', data], (): any => getEmployerRequestListData(data), {
    select: (response: IMerchantRequestListData['data']) => {
      return response.data;
    },
  });
};
